<template>
    <span>
      <div
        v-for="(item, index) in config"
        :key="index"
        :field="item.field"
        :title="item.title"
        :height="item.height"
        :sort="item.sort"
        :filter="item.filter ? JSON.stringify(item.filter) : ''"
        :translateDomain="item.translateDomain"
        :align="item.align ? item.align : defaultConfig.align"
        :width="item.width"
      />
    </span>
</template>
<script>
export default {
  props: {
    config: {
       type: Array,
        default: ()=>{
            return [];
        }
    }
  },
  data () {
    return {
      //各选项的默认值
      defaultConfig :{
        width: 175,
        align: "center",
      }
    }
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/LayuiTableConfig.vue